<template>
  <section>
    <section class="hero is-danger">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            404
          </h1>
          <h2 class="subtitle">
            Page not found
          </h2>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
  export default {
    name: '404'
  }
</script>




// WEBPACK FOOTER //
// NotFound.vue?855f6e90